export enum GenCartType {
    FINISHED_GOODS = 'FINISHED_GOODS',
    SUBSCRIPTION = 'SUBSCRIPTION',
    SERVICE_PARTS = 'SERVICE_PARTS',
  }